export * from './message-center.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/core/message/message-center/index.ts